import { Component, forwardRef, Input, OnInit, Provider, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { NzSelectComponent } from 'ng-zorro-antd';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { VerificationCodeCore } from './gen-code';

export const EXE_SELECT_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CodeComponent),
  multi: true,
};

@Component({
  selector: 'app-code',
  template: `
    <nz-input-group [nzSuffix]="suffixCode" [nzPrefix]="prefixCode" [class.ant-input-disabled]="disabled">
      <input
        type="text"
        nz-input
        placeholder="请输入12位大写字母加数字"
        [(ngModel)]="code"
        [maxlength]="12"
        [pattern]="reg"
        [disabled]="disabled"
        (ngModelChange)="codeChange()"
      />
    </nz-input-group>
  `,
  providers: [EXE_SELECT_VALUE_ACCESSOR],
})
export class CodeComponent implements OnInit, ControlValueAccessor {
  @Input() prefixCode = '';

  suffixCode = '';

  code = '';

  value = null;

  /**
   * 正则验证
   */
  reg = /^[\dA-Z]{12}$/;

  disabled: boolean;
  constructor() {}

  ngOnInit(): void {}

  propagateChange = (_: any) => {};

  writeValue(value: string) {
    if (!value) {
      this.code = '';
      this.suffixCode = '';
      return;
    }
    if (value.length === 18) {
      const [pre, mid, suffix] = /^([\da-zA-Z]{5})([\da-zA-Z]{12})([\da-zA-Z]{1})$/
        .exec(value)
        .slice(1);

      this.code = mid;
      this.prefixCode = pre;
      this.suffixCode = suffix;
    }

    if (value.length === 12) {
      this.code = value;
      this.codeChange();
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}

  setDisabledState(disabled) {
    this.disabled = disabled;
  }

  codeChange() {
    this.suffixCode = VerificationCodeCore.GetVerificationCode(
      `${this.prefixCode}${this.code}`
    );
    if (this.suffixCode) {
      this.propagateChange(`${this.prefixCode}${this.code}${this.suffixCode}`);
    } else {
      this.propagateChange('');
    }
  }
}
